import { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import axios from 'axios';
import parse from 'html-react-parser';
import "./styles/article.css";

function Article({settingCurrentPageForHeader}) {

    useEffect(()=> {
        settingCurrentPageForHeader("articles");
    }, [settingCurrentPageForHeader]);

    const currentArticle = useParams();

    const [articleState, setArticleState] = useState({
        content : null,
        status : false
    });

    useEffect(() => {
        axios.get('/api/art' + currentArticle.artId + '.json')
            .then(function (response) {
                setArticleState({
                    content : response.data,
                    status : true
                });
            })
            .catch(function (error) {
                setArticleState({
                    content : <p className="text-center">Ups! Błąd aplikacji</p>,
                    status : false
                });
            })
            .finally(function () {
                if(document.querySelector(".loading")) {
                    document.querySelector(".loading").remove();
                }
            });
    }, [currentArticle.slug, currentArticle.artId]);

    function articleResults(data) {
        let articleContent;
        if(data.status) {
            articleContent = <>
                <article>
                    <h2>{parse(data.content.title)}</h2>
                    <img src={data.content.img ? data.content.img : ""} alt="" />
                    {parse(data.content.content)}
                    <p className="author">{parse(data.content.author)}</p>
                    <hr />
                    {data.content.footnote && (
                        <>
                            <div className="footnote">{parse(data.content.footnote)}</div>
                            <hr />
                        </>
                    )}
                    <p className="date">
                    Data publikacji: {parse(data.content.date)}
                    </p>
                </article>
                <div className="center">
                    <Link to="/artykuly" className="btn">Wszystkie artykuły <img src="/img/arrow.svg" alt=">" /></Link>
                </div>
            </>;
        } else {
            articleContent = data.content;
        }
        return articleContent;
    }

    return (
        <main>
            <div className="menu-space-container"></div>
            <div className="standard-padding">
                <div className="container">
                    <div className="loading"><img src="/img/loader.png" alt="Wczytywanie..." /></div>
                    {articleResults(articleState)}
                </div>
            </div>
        </main>
    );
}

export default Article;